import type { ChartSegment } from './cpc25Charts';

interface Cpc25BarChartProps {
    title: string;
    segments: ChartSegment[];
    emptyMessage?: string;
}

// Barra horizontal segmentada + legenda, no estilo do ExpenseCompositionBar (div+Tailwind,
// sem lib de gráfico). Genérica: recebe segmentos já calculados (provisão por entidade ou
// casos por classificação). Dark mode.
const Cpc25BarChart = ({ title, segments, emptyMessage = 'Sem dados' }: Cpc25BarChartProps) => (
    <div className="rounded-lg border border-gray-200 dark:border-slate-700 p-4 space-y-3">
        <h3 className="text-sm font-medium text-gray-700 dark:text-gray-200">{title}</h3>
        {segments.length === 0 ? (
            <p className="text-xs text-gray-400 dark:text-gray-500 py-4 text-center">{emptyMessage}</p>
        ) : (
            <>
                <div
                    className="flex h-4 w-full overflow-hidden rounded-full bg-gray-100 dark:bg-slate-700"
                    role="img"
                    aria-label={`${title}: ${segments.map((s) => `${s.label} ${s.formatted}`).join(', ')}`}
                >
                    {segments.map((s) => (
                        <div
                            key={s.key}
                            style={{ width: `${s.pct}%`, backgroundColor: s.color }}
                            title={`${s.label}: ${s.formatted} (${s.pct.toLocaleString('pt-BR', { maximumFractionDigits: 1 })}%)`}
                        />
                    ))}
                </div>
                <div className="flex flex-wrap gap-x-4 gap-y-1.5">
                    {segments.map((s) => (
                        <div key={s.key} className="flex items-center gap-1.5 text-xs">
                            <span className="inline-block h-2.5 w-2.5 rounded-full shrink-0" style={{ backgroundColor: s.color }} />
                            <span className="text-gray-600 dark:text-gray-300">{s.label}</span>
                            <span className="font-medium text-gray-900 dark:text-white">{s.formatted}</span>
                        </div>
                    ))}
                </div>
            </>
        )}
    </div>
);

export default Cpc25BarChart;
